import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  position: relative;
`;

const FilterLabelWrapper = styled.div`
  position: absolute;
  top: -12px;
  left: 16px;
  background: #fff;
  padding: 0 4px;
`;

const FilterWrapper = styled.div`
  width: 300px;
`;

export default { Container, FilterLabelWrapper, FilterWrapper };
